/* CYBER SENSATOS 2026 · comportamiento de la capa Cyber (sin librerías)
   1 sello del hero · 2 chips + filtro FLIP · 3 revelado desde la 2.ª fila + pulso de insignia
   4 botón fijo · 5 CTA de tarjeta · 6 confirmación de agregado · 7 conteo del ahorro en el carrito */
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const raf = (fn) => requestAnimationFrame(() => requestAnimationFrame(fn));

  /* 1 · Sello: entra después de que el número ya está pintado */
  const sello = document.querySelector('[data-cy-sello]');
  if (sello) {
    if (reduce) sello.classList.add('is-in', 'no-anim');
    else raf(() => sello.classList.add('is-in'));
  }

  /* 2 · Chips de filtro (cliente, sin recarga) */
  const cards = Array.from(document.querySelectorAll('[data-cy-cards] .cy-card'));
  const chipsRow = document.querySelector('[data-cy-chips]');
  if (chipsRow && cards.length) {
    const chips = Array.from(chipsRow.querySelectorAll('[data-cy-chip]'));
    const ink = chipsRow.querySelector('[data-cy-ink]');
    const moveInk = (b) => { if (!ink || !b) return; ink.style.left = b.offsetLeft + 'px'; ink.style.width = b.offsetWidth + 'px'; };
    const current = () => chips.find((c) => c.getAttribute('aria-pressed') === 'true') || chips[0];
    moveInk(current());
    addEventListener('resize', () => moveInk(current()), { passive: true });

    const apply = (btn) => {
      chips.forEach((c) => c.setAttribute('aria-pressed', String(c === btn)));
      moveInk(btn);
      btn.scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduce ? 'auto' : 'smooth' });
      const min = Number(btn.dataset.min) || 0, max = Number(btn.dataset.max ?? 100);
      const first = new Map(cards.map((c) => [c, c.getBoundingClientRect()]));
      let shown = 0;
      cards.forEach((c) => {
        const d = Number(c.dataset.discount) || 0;
        const ok = d >= min && d <= max;
        c.classList.toggle('is-hidden', !ok);
        if (ok) shown++;
      });
      const empty = document.querySelector('[data-cy-empty]');
      if (empty) empty.hidden = shown > 0;
      if (reduce) return;
      cards.forEach((c) => {
        if (c.classList.contains('is-hidden')) return;
        const a = first.get(c), b = c.getBoundingClientRect();
        const dx = a.left - b.left, dy = a.top - b.top;
        if (!dx && !dy) return;
        c.style.transition = 'none';
        c.style.transform = `translate(${dx}px, ${dy}px)`;
        requestAnimationFrame(() => {
          c.style.transition = 'transform .28s cubic-bezier(.2,.7,.2,1)';
          c.style.transform = '';
          c.addEventListener('transitionend', () => { c.style.transition = ''; }, { once: true });
        });
      });
    };
    chips.forEach((b) => b.addEventListener('click', () => apply(b)));
    document.querySelector('[data-cy-reset]')?.addEventListener('click', () => apply(chips[0]));
  }

  /* 3 · Revelado (una sola vez, desde la 2.ª fila) y pulso de la insignia al entrar en pantalla */
  if (cards.length) {
    if ('IntersectionObserver' in window && !reduce) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e, i) => {
          if (!e.isIntersecting) return;
          const el = e.target;
          if (el.hasAttribute('data-cy-reveal')) setTimeout(() => el.classList.add('is-in'), i * 40);
          el.querySelector('[data-cy-badge]')?.classList.add('is-pulsing');
          io.unobserve(el);
        });
      }, { rootMargin: '0px 0px -8% 0px' });
      cards.forEach((c) => io.observe(c));
    } else {
      cards.forEach((c) => c.classList.add('is-in'));
    }
  }

  /* 4 · Botón fijo: sube cuando el hero sale por arriba, baja cuando vuelve */
  const fab = document.querySelector('[data-cy-fab]');
  const hero = document.querySelector('[data-cy-hero]');
  if (fab && hero && 'IntersectionObserver' in window) {
    new IntersectionObserver(([e]) => {
      fab.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(hero);
  }

  /* 5 · CTA de tarjeta de un solo tamaño: envía el formulario nativo del tema (AddToCart intacto) */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-cy-submit]');
    if (!b) return;
    const form = b.closest('.cy-card')?.querySelector('product-form form');
    if (!form) return;
    b.dataset.label = b.textContent;
    b.textContent = 'Agregando…';
    b.classList.add('is-loading');
    form.requestSubmit();
  });

  /* 6 · Confirmación: «✓ En tu carrito» y rebote corto del ícono de la bolsa */
  document.addEventListener('variant:add', () => {
    document.querySelectorAll('.cy-card__cta.is-loading').forEach((b) => {
      b.classList.remove('is-loading');
      b.classList.add('is-done');
      b.textContent = '✓ En tu carrito';
      setTimeout(() => { b.classList.remove('is-done'); b.textContent = b.dataset.label || 'Elegir talla'; }, 1800);
    });
    if (reduce) return;
    const bag = document.querySelector('.shopify-section--header a[href$="/cart"]');
    if (bag && bag.animate) bag.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.18)' }, { transform: 'scale(1)' }], { duration: 300, easing: 'cubic-bezier(.2,.7,.2,1)' });
  });
  document.addEventListener('cart:error', () => {
    document.querySelectorAll('.cy-card__cta.is-loading').forEach((b) => { b.classList.remove('is-loading'); b.textContent = b.dataset.label || 'Elegir talla'; });
  });

  /* 7 · «Ahorras $X» cuenta hacia arriba (600 ms) cuando se abre el cajón */
  const fmt = (cents) => '$' + Math.round(cents / 100).toLocaleString('en-US'); /* mismo formato que la tienda: $45,000 */
  class CyberCountUp extends HTMLElement {
    connectedCallback() {
      const drawer = this.closest('cart-drawer');
      if (drawer && !drawer.hasAttribute('open')) { this.textContent = fmt(Number(this.dataset.amount) || 0); return; }
      this.play();
    }
    play() {
      const cents = Number(this.dataset.amount) || 0;
      if (reduce || !cents) { this.textContent = fmt(cents); return; }
      const t0 = performance.now(), dur = 600;
      const step = (now) => {
        const p = Math.min(1, (now - t0) / dur), ease = 1 - Math.pow(1 - p, 3);
        this.textContent = fmt(cents * ease);
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    }
  }
  if (!customElements.get('cyber-count-up')) customElements.define('cyber-count-up', CyberCountUp);
  const drawer = document.querySelector('cart-drawer');
  if (drawer) {
    new MutationObserver(() => {
      if (drawer.hasAttribute('open')) drawer.querySelectorAll('cyber-count-up').forEach((el) => el.play());
    }).observe(drawer, { attributes: true, attributeFilter: ['open'] });
  }
})();
